if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);

        console.log('1',data.cartQuantity);
        console.log('2',this.input.value);

        if ( data.cartQuantity > 0 && this.input.value == 0 ){
          //alert('product already in cart');
          document.querySelector(".qtyMaxLimitMsg").style.display = "block";
        } else {
          document.querySelector(".qtyMaxLimitMsg").style.display = "none";
        }

        
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// select all elements with class "button"
const additionalVarinats = document.querySelectorAll(".additional-variants");

// loop through each button
additionalVarinats.forEach((button) => {
  button.addEventListener("click", function (variant) {
    var ele = document.querySelectorAll(".product-form__input input");
    let currentUrl = window.location.href;
    let newUrl = currentUrl.split("?");
    let formId = document.querySelector(".product-variant-id");
    let mediaId = this.dataset.mediaId;
    let productTitle = document.querySelector(".product h1");
    let productImage = document.querySelector(".product__media-item--variant.is-active .product__media img");
    let productSku = document.querySelector(".product__sku");
    let productInventory = document.querySelector(".inventori-main .product__inventory");
    const mediaGalleries = document.querySelectorAll(".product__column-sticky");
    for (var i = 0; i < ele.length; i++) {
      ele[i].checked = false;
    }
    window.history.pushState(null, null, newUrl[0]);
    formId.value = this.dataset.variantId;
    productSku.innerHTML = this.dataset.sku;

     //AK Custom code
    var sold_var = this.getAttribute('data-qty-sold');
    if(sold_var == 'true'){
      document.querySelector('.product-form__submit').setAttribute('disabled','disabled');
      var btn_text = document.querySelector('.product-form__submit .btn_text').getAttribute('data-sold-btn-text');
      if(btn_text){
        var btn_text = document.querySelector('.product-form__submit .btn_text').innerHTML = btn_text;
      }
      
    }else{
      document.querySelector('.product-form__submit').removeAttribute('disabled');
      var btn_text = document.querySelector('.product-form__submit .btn_text').getAttribute('data-ori-btn-text');
      if(btn_text){
        var btn_text = document.querySelector('.product-form__submit .btn_text').innerHTML = btn_text;
      }
    }

    var max_qty = parseInt(this.getAttribute('data-max'));
    if(max_qty){
        var var_id = this.dataset.variantId;
        //new cart qty code

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          //console.log(cart); // Outputs the cart JSON data to the console
          // You can now work with the cart object here
          var items = cart.items;
          var item_have = false;
          for(var i=0;i<items.length;i++){
            if(items[i].id == var_id){
              var item_have = true;

              var cart_qty = items[i].quantity;
              if(cart_qty >= max_qty){
                  document.querySelector('[name="quantity"]').setAttribute('data-max', max_qty);
                  document.querySelector('[name="quantity"]').setAttribute('max', 0);
                  document.querySelector('[name="quantity"]').value = 0;
                  document.querySelector('.quantity__button[name="plus"]').classList.add('disabled');
                  var qty_rule = document.querySelector('.quantity__rules-cart');
                  if(qty_rule){
                    qty_rule.classList.remove('hidden');
                    qty_rule.querySelector('.quantity__rules-cart .quantity-cart').innerHTML = cart_qty;
                  }
                  var qtymax_limit = document.querySelector('.qtyMaxLimitMsg');
                  if(qtymax_limit){
                    // qtymax_limit.classList.remove('hidden');
                    qtymax_limit.style.display = "block";
                  }
                 // document.querySelector('[name="quantity"]').setAttribute('data-max', max_qty);
              }else{
                var minus_qty = max_qty - cart_qty;
                document.querySelector('[name="quantity"]').setAttribute('data-max', max_qty);
                document.querySelector('[name="quantity"]').setAttribute('max', minus_qty);
                document.querySelector('[name="quantity"]').value = 1;
                document.querySelector('.quantity__button[name="plus"]').classList.remove('disabled');
                 var qty_rule = document.querySelector('.quantity__rules-cart');
                  if(qty_rule){
                    qty_rule.classList.remove('hidden');
                    qty_rule.querySelector('.quantity__rules-cart .quantity-cart').innerHTML = cart_qty;
                  }
                  var qtymax_limit = document.querySelector('.qtyMaxLimitMsg');
                  if(qtymax_limit){
                    // qtymax_limit.classList.add('hidden');
                    qtymax_limit.style.display = "none";
                  }
                
              }
            }
          }

          console.log(item_have);
          if(!item_have){
            document.querySelector('[name="quantity"]').setAttribute('data-max', max_qty);
            document.querySelector('[name="quantity"]').setAttribute('max', max_qty);
            document.querySelector('[name="quantity"]').value = 1;
            document.querySelector('.quantity__button[name="plus"]').classList.remove('disabled');

              var qty_rule = document.querySelector('.quantity__rules-cart');
              if(qty_rule){
                qty_rule.classList.add('hidden');
              }
              var qtymax_limit = document.querySelector('.qtyMaxLimitMsg');
              if(qtymax_limit){
                // qtymax_limit.classList.add('hidden');
                qtymax_limit.style.display = "none";
              }
          }
        })
        .catch(error => {
          console.error('Error fetching the cart data:', error);
        });

      
      // console.log('get qty')
      // // document.querySelector('[name="quantity"]').setAttribute('data-max',max_qty);
      // document.querySelector('[name="quantity"]').setAttribute('data-max', max_qty);
      // document.querySelector('[name="quantity"]').setAttribute('max', max_qty);

      // var value = parseInt(document.querySelector('[name="quantity"]').value);
      // console.log(value);
      // if(value > max_qty){
      //   document.querySelector('[name="quantity"]').value = 1;
      //   document.querySelector('.quantity__button[name="plus"]').classList.remove('disabled');
      // }else{
      //   console.log('nooooo')
      //   document.querySelector('.quantity__button[name="plus"]').classList.remove('disabled');
      // }
      
    }else{
      document.querySelector('[name="quantity"]').removeAttribute('data-max');
      document.querySelector('[name="quantity"]').setAttribute('max','null');
      document.querySelector('.quantity__button[name="plus"]').classList.remove('disabled');
      document.querySelector('[name="quantity"]').value = 1;

      var qty_rule = document.querySelector('.quantity__rules-cart');
      if(qty_rule){
        qty_rule.classList.add('hidden');
      }
      var qtymax_limit = document.querySelector('.qtyMaxLimitMsg');
      if(qtymax_limit){
        // qtymax_limit.classList.add('hidden');
        qtymax_limit.style.display = "none";
      }
      
      
    }
    //end AK Custom code
    
    mediaGalleries.forEach((mediaGallery) => {
      let activeMedia = mediaGallery.querySelectorAll(
        ".product__media-list li"
      );
      activeMedia.forEach((mediaGalleryList) => {
        let activeMediaId = mediaGalleryList.dataset.mediaId;
        if (mediaId == activeMediaId) {
          mediaGallery.setActiveMedia(activeMediaId, true);
        }
        else
        {
          mediaGallery.setActiveMedia(activeMediaId, false);
        }
      });
    });
     productTitle.innerHTML = this.dataset.title;
     document.querySelector(".product__title h1").style.display = "block"; 
     document.querySelector(".product__title a").style.display = "none"; 
     // console.log(this.dataset.availabilty);
     if(this.hasAttribute("data-availabilty")){
      document.querySelector(".product-sku-number").style.marginRight = "62px";
     productInventory.innerHTML = `<div class="product-code-3">Availibility</div>
                       <div class="low_flex">
                      <svg width="15" height="15" aria-hidden="true">
                        <circle cx="7.5" cy="7.5" r="7.5" fill="rgb(226, 30, 60, 0.3)"></circle>
                        <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="#e21e3c"></circle>
                      </svg><div class="low_stock">${this.dataset.availabilty}</div></div>`;
     }
    else{
      productInventory.innerHTML = "";
    }
    let productPrice = this.querySelector(".custom-price").innerHTML;
    document.querySelector(".product-price-container").innerHTML = productPrice;
    let productDescription = this.querySelector(".custom-product-description").innerHTML;
    document.querySelector(".product__description").innerHTML = productDescription;
    let productIncludes = this.querySelector(".custom-product-includes").innerHTML;
    if(document.querySelector(".product__accordion .accordion__content")){
      document.querySelector(".product__accordion .accordion__content").innerHTML = productIncludes;
    }
    

    // Fire your custom event at the end
    const metafield = button.querySelector("div.xsell_metafield").innerHTML;
    console.log("metafield", metafield)
    const cross_sells = eval(metafield) || [];
    console.log("cross_sells", cross_sells)
    if(cross_sells){
var promises = [];
xsellLib.xsellproductdataCustom = []
cross_sells.forEach(x => {
  promises.push(xsellLib.getProductData(x));
})

Promise.all(promises)
  .then(function(dataArr) {
    dataArr.forEach(function(productData) {
      if (typeof productData != "undefined") {
        var _productData = {};
        try {
          // in case a redirect exists and the return value is an HTML page
          _productData = JSON.parse(productData[0]);
        } catch (_error) {
          console.log("Invalid Product " + productData[1].handle);
          return;
        }
        var xsorder = productData[1].order;

        if (
          xsellLib.settings.xsmustbeavailable &&
          !_productData.available
        ) {
          return;
        }

        // don't add if already in the array (could be from recommendations)
        var found = xsellLib.xsellproductdataCustom.filter(function(product) {
          return product.handle == _productData.handle;
        });
        if (found[0]) {
          return;
        }

        _productData.order = xsorder;
        _productData.url = _productData.url.split("?")[0];
        xsellLib.xsellproductdataCustom.push(_productData);
      }
    });
    if(xsellLib.xsellproductdataCustom.length > 0){
      window.XSellWindowShop.popupInit(xsellLib.xsellproductdataCustom, true);  
    }else{
      const button = document.querySelector('.product-form__submit');
      if (button) {
        const clonedButton = button.cloneNode(true);
        button.parentNode.replaceChild(clonedButton, button);
      }
    }
    
    
  })
  .catch(function(err) {
    console.log(err);
  });
}
    
  });
});
 
 
  setTimeout(function(){
  let xsellInterval = setInterval(function(){
    if(window.XSellWindowShop){
      if(xsellSettings.modal_upsells.length > 0){
        xsellLib.buildUpsellXsells(
          xsellLib.settings.modal_upsells || [],
          function() {
            window.XSellWindowShop.popupInit(xsellLib.upsellProductData, true);
          }
        );
        
      }else{
        const button = document.querySelector('.product-form__submit');
        if (button) {
          const clonedButton = button.cloneNode(true);
          button.parentNode.replaceChild(clonedButton, button);
        }
      }
      clearInterval(xsellInterval)
    }
  },500);
  }, 1000)
 